<template lang="pug">
div
    .box
        .box-header.dker
            h3
                span(v-if="purchaseOrder.status == 0") Purchase Order - Step 2 of 4
                span(v-if="purchaseOrder.status == 1") Purchase Order - Step 3 of 4
                span(v-if="purchaseOrder.status == 2") Purchase Order - Step 4 of 4

        .box-divider.m-a-0.p-a-0

        .box-body
            .p-a
                step-wizard(:status="purchaseOrder.status")

        .box-header
            h3 General

        .box-divider.m-a-0.p-a-0

        .box-body
            .row
                .col-sm-6
                    table.table.table-borderless
                        tr
                            td._500 Order No.
                            td {{ purchaseOrder.order_no }}

                        tr
                            td._500 Status
                            td
                                span.label.blue-grey(v-if="isOpen") {{ completionStatus }}
                                span.label.yellow(v-if="isOrdered") {{ completionStatus }}
                                span.label.green(v-if="hasFinalized") {{ completionStatus }}

                        tr
                            td._500 Order Date
                            td
                                vue-datepicker(
                                    v-show="canEdit",
                                    type="date"
                                    v-model="orderDate",
                                    lang="en",
                                    :editable="false",
                                    :clearable="false",
                                    :shortcuts="false",
                                    format="DD/MM/YYYY"
                                )
                                span(v-show="!canEdit") {{ formattedDate(orderDate) }}

                        tr
                            td._500 Delivery Address
                            td
                                textarea.form-control(
                                    rows="3",
                                    key="delivery_address",
                                    :value="purchaseOrder.delivery_address",
                                    v-if="canEdit",
                                    @input="setPurchaseOrderAttr({ key: 'delivery_address', value: $event.target.value })"
                                )
                                span(v-else) {{ purchaseOrder.delivery_address }}

                .col-sm-6
                    table.table.table-form-input                
                        tr
                            td._500 Expected Delivery Date
                            td
                                vue-datepicker(
                                    v-show="canEdit",
                                    type="date"
                                    v-model="deliveryDate",
                                    lang="en",
                                    :editable="false",
                                    :clearable="false",
                                    :shortcuts="false",
                                    format="DD/MM/YYYY"
                                )
                                span(v-show="!canEdit") {{ formattedDate(deliveryDate) }}

                        tr
                            td._500 Outlet
                            td {{ outlet.name }}

                        tr
                            td._500 Supplier
                            td {{ supplier.name }}

                        tr
                            td._500 General Notes
                            td
                                textarea.form-control(
                                    key="remarks",
                                    rows="3",
                                    :value="purchaseOrder.remarks",
                                    v-if="! hasFinalized && canUpdate",
                                    @input="setPurchaseOrderAttr({ key: 'remarks', value: $event.target.value })"
                                )
                                span(v-else) {{ purchaseOrder.remarks }}

</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import stepWizard from './purchase-order-step.vue';
import purchaseOrderMixin from './purchase-order-mixin';

export default {
    inject: ['$validator'],

    components: { stepWizard },

    mixins: [purchaseOrderMixin],

    computed: {
        ...mapState('purchaseOrder', ['purchaseOrder']),

        ...mapGetters('purchaseOrder', [
            'outlet',
            'purchaseOrder',
            'supplier',
            'completionStatus',
            'hasFinalized',
        ]),

        orderDate: {
            get() {
                return this.purchaseOrder.order_date;
            },
            set(date) {
                const value = moment(date).format('YYYY-MM-DD');
                this.setPurchaseOrderAttr({ key: 'order_date', value });
            },
        },
        deliveryDate: {
            get() {
                return this.purchaseOrder.delivery_date;
            },
            set(date) {
                const value = moment(date).format('YYYY-MM-DD');
                this.setPurchaseOrderAttr({ key: 'delivery_date', value });
            },
        },
    },

    methods: {
        ...mapActions('purchaseOrder', ['setPurchaseOrderAttr']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/purchase-order/purchase-order-edit-info.vue